import { Navbar, Container, Button, Row, Col } from "react-bootstrap";
import { Tooltip } from 'antd';

import logoBetrack from "../../ASSETS/IMAGES/beetrack.png";
import logoSTK from "../../ASSETS/IMAGES/logo-header.png";
import { ReactChild, ReactFragment, ReactPortal } from "react";


import { useIsOnline } from 'react-use-is-online';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse, faGlobe, faBan, faRectangleList } from "@fortawesome/free-solid-svg-icons";







export default function Menu(props: { logo: any; titulo: boolean | ReactChild | ReactFragment | ReactPortal | null | undefined; }) {

  const { isOnline, isOffline, error } = useIsOnline();

  let logo = props.logo;

  return (
    <>
      <Navbar className="navbar " bg="dark" expand="lg">
        <Container>

          <Navbar.Brand>
            <div className="row">



              {
                (logo === "beetrack") ? (
                  <div className="col">
                    <img alt="Beetrack" src={logoBetrack} style={{ height: "35px" }} />
                  </div>
                ) : (
                  <div className="col">
                    <img alt="Beetrack" src={logoSTK} style={{ height: "35px" }} />

                  </div>
                )
              }


              <div className="col">
                <h5 style={{ color: "white" }}>  {props.titulo} </h5>
              </div>


            </div>
          </Navbar.Brand>

          <Col></Col>
          <Col></Col>
          <Col></Col>
          <Col></Col>

          <Col>
            {
              isOnline ? <>
                <Tooltip placement="bottom" title="Con Conexión a Internet">
                  <FontAwesomeIcon icon={faGlobe} style={{ color: "Green" }} />
                </Tooltip>
              </> : <>
                <Tooltip placement="bottom" title="Sin Conexión a Internet">
                  <FontAwesomeIcon icon={faBan} style={{ color: "Red" }} />
                </Tooltip>
              </>
            }

          </Col>
        </Container>
      </Navbar>
    </>
  );
}
